import React from 'react';
import styled from 'styled-components';

const DynamicWidthDivFC = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: className
  });
};

const StyledDiv = styled(DynamicWidthDivFC)`
  width: ${props => `${props.widthPercent}%`} !important;
  background-color: ${props => props.color};
  border-radius: 2px;
  max-width: 100%;
  height: 100%;
`;
export default StyledDiv;